import gsap from "gsap";
import Typewriter from "typewriter-effect/dist/core";

gsap.from(".computing_clouding_left_box_image", {
    duration: 1,
    y: 10,
    repeat: -1,
    yoyo: true,
});
gsap.from(".computing_clouding_right_box_image", {
    duration: 1,
    y: 10,
    repeat: -1,
    yoyo: true,
});
gsap.from(".computing__feature_left_image", {
    duration: 1,
    y: 15,
    repeat: -1,
    yoyo: true,
});
gsap.from(".computing__feature_right_image", {
    duration: 1,
    y: 15,
    repeat: -1,
    yoyo: true,
});
// gsap.from(".computing__cloud__main__image", {
//     opacity: 0,
//     x: -200,
//     duration: 1
// });
gsap.from(".computing__cloud_about_down", {
    opacity: 0,
    duration: 1,
    y: 30,
    repeat: -1,
    yoyo: true,
});

11220;
// gsap.from(".computing__cloud_top_image", {
//     duration: 1,
//     y: 30,
//     repeat: -1,
//     yoyo: true
// });

document
    .getElementById("copy-command")
    .addEventListener("click", () =>
        navigator.clipboard.writeText(
            'sudo bash -c "$(curl -sL https://skycloud.ir/install/cli/install )"'
        )
    );
const obs = new IntersectionObserver((entries, observer) => {
    // Do not run if not intersection (avoid running timeouts)
    if (!entries[0].isIntersecting) return;

    const loginRes = document.querySelector("#login-res");
    const deployRes = document.querySelector("#deploy-res");
    const tr_login = new Typewriter("#tr-login", {
        cursor: "",
    });
    tr_login.changeDelay(70)
        .typeString(" skycloud login\n")
        .pasteString(
            ' <span class="terminal-text text-green">Username:</span> '
        )
        .pasteString("<br/>")
        .pasteString("> ")
        .typeString("hossein@skycloud.ir")
        .pasteString("<br/>")
        .pasteString('<span class="terminal-text text-green">Password:</span> ')
        .pasteString("<br/>")
        .pasteString("> ")
        .typeString("********")
        .pasteString("<br/>")
        .pasteString(
            ' <span class="terminal-text text-green">Authentication </span> '
        )


        .pasteString("⏳").pasteString('.').pasteString('.').pasteString('.')
        .deleteChars(5)
        .pasteString('✅')
        .pauseFor(1000)
        .pasteString('<br/>')
        .pasteString('<span class="terminal-text text-green"> Welcome to the SkyCloud CLI !</span>')
      .pasteString('<br/>')
        .changeDelay(1)
        .pasteString('<span class="fixed-label"><span>sky@Cloud</span><span>:</span><span>~</span><span>$</span></span>')
        .changeDelay(100)
        .typeString(' skycloud servers')
        .pasteString('<br />')
        .changeDelay(1)
        .pasteString('<span class="terminal-text ">'+
            '+----+----------------- Servers --------+-------------+\n' +
            '| ID |        Name        | Power State | Region Name |\n' +
            '+----+--------------------+-------------+-------------+\n' +
            '| 84 | SOFT_VPS_COST_2_84 |     on      |   اصفهان    |\n' +
            '| 89 | SOFT_VPS_COST_2_89 |     off     |   اصفهان    |\n' +
            '+----+--------------------+-------------+-------------+' +
            '</span>')
        .pasteString('<br />')

        .start();
    const tr_deploy = new Typewriter("#tr-deploy");
    tr_deploy.typeString("sky deploy");

    setTimeout(() => {
        loginRes.innerText = ">>> Hello Hossein 👋";

        document.getElementById("deploy-para").style.visibility = "visible";
        tr_deploy.start();
        const deployTextBefore = ">>> Now deploying your awesome website\n";
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣷⣀⣀⣀⣀⣀⣀ 23% `;
        }, 3000);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣄⣀⣀⣀⣀⣀ 47% `;
        }, 3500);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣶⣀⣀⣀⣀⣀ 56%`;
        }, 4000);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣀⣀⣀ 77% `;
        }, 4500);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿ 100% ✓ `;
        }, 5000);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿ 100% ✓✓ `;
        }, 5500);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿ 100% ✓✓✓ `;
        }, 6000);
        setTimeout(() => {
            deployRes.innerText = `${deployTextBefore}>>> ⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿ 100% ✓✓✓ \n>>> Successfully deployed at: https://example.com`;
        }, 7000);
    }, 3000);
});

obs.observe(document.querySelector(".usage"));
